import WrapLoginModal from './wrap-login-modal/index.jsx';
import './login.css';
import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import SubmitLoginButton from './submit-login-button.jsx';
import Button from '../button/button.jsx';
import {
    injectIntl,
    defineMessages,
    FormattedMessage
} from 'react-intl';
import VerifyCode from './verify-code.jsx';
import {encryptedData} from '../lib/api/rsa.js';
// import closeLoginModal from '../reducers/modals.js';
import {
    requestEmailCode,
    requestMobileCode,
    requestEmailRegister,
    requestRegister,
    requestLoginByEmailAndUserName,
    requestLogin,
    requestForgetByEmail,
    requestForget
} from '../lib/api/login.js';
import backIcon from './icon--back.svg';
import {message, Popover, Input} from 'antd';
import { TabList, Tabs, TabPanels, TabPanel, Tab } from "@chakra-ui/react";
// import disableEvent from '../lib/scratch-extends/disableEventUtils';
import {getMobileOS} from '../lib/supported-browser';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {connect} from 'react-redux';
import {compose} from 'redux';
import { setUserLoginMode } from '../store/user-state'
import modalHeadBack from '../lib/assets/modalWifi.png'
import { getTurnstileToken, preloadTurnstile, mountTurnstile, removeTurnstile } from '../lib/turnstile.js';

const messages = defineMessages({
    loginByPwd: {
        id: 'gui.account.loginByPwd',
        defaultMessage: 'Login with password',
        description: 'login by password'
    },
    loginByCode: {
        id: 'gui.account.loginByCode',
        defaultMessage: 'Login with verification code',
        description: 'login by code'
    },
    forgetPassword: {
        id: 'gui.account.forgetPassword',
        defaultMessage: 'Forgot?',
        description: 'forget password'
    },
    emailPlaceholder: {
        id: 'gui.account.emailPlaceholder',
        defaultMessage: 'Please enter an email address',
        description: 'Placeholder text for email input field'
    },
    mobilePlaceholder: {
        id: 'gui.account.mobilePlaceholder',
        defaultMessage: 'Please enter phone number',
        description: 'Placeholder text for mobile input field'
    },
    passwordConfirm: {
        id: 'gui.homePage.passwordConfirm',
        defaultMessage: 'Please password confirmation',
        description: 'Placeholder text for password input field'
    },
    passwordPlaceholder: {
        id: 'gui.account.passwordPlaceholder',
        defaultMessage: 'Please enter password',
        description: 'Placeholder text for password input field'
    },
    codePlaceholder: {
        id: 'gui.account.verifyCodePlaceholder',
        defaultMessage: 'Please enter verification code',
        description: 'Placeholder text for verify code input field'
    },
    errorCheckboxMessage: {
        id: 'gui.account.errorCheckboxMessage',
        defaultMessage:
            'Please enter your email address and agree to the User Agreement',
        description: 'Error message for checkbox'
    },
    errorEmptyMessage: {
        id: 'gui.account.errorEmptyMessage',
        defaultMessage: 'Username or password cannot be empty',
        description: 'Error message for empty input'
    },
    errorCheckboxMessage2: {
        id: 'gui.account.errorCheckboxMessage2',
        defaultMessage: 'Please read and agree to the User Agreement',
        description: 'Error message for checkbox'
    },
    errorMobileFormatMessage: {
        id: 'gui.account.errorMobileFormatMessage',
        defaultMessage: 'Mobile format is incorrect',
        description: 'Error message for mobile format'
    },
    errorEmailFormatMessage: {
        id: 'gui.account.errorEmailFormatMessage',
        defaultMessage: 'Email format is incorrect',
        description: 'Error message for email format'
    },
    errorCodeEmptyMessage: {
        id: 'gui.account.errorCodeEmptyMessage',
        defaultMessage: 'Verification code cannot be empty',
        description: 'Error message for empty input'
    },
    welcomeTitle: {
        id: 'gui.account.welcome',
        defaultMessage: 'Welcome to the MatataCode',
        description: 'Label for login success'
    },
    resetPasswordSuccess: {
        id: 'gui.account.resetPasswordSuccess',
        defaultMessage: 'Reset Password Success',
        description: 'reset password success'
    },
    loginSuccess: {
        id: 'gui.account.loginSuccess',
        defaultMessage: 'Login Successfully',
        description: 'Label for login success'
    },
    restPasswordTitle: {
        id: 'general.resetPassword',
        defaultMessage: 'Reset password',
        description: 'Reset password'
    },
    signPlaceholder: {
        id: 'gui.account.signPlaceholder',
        defaultMessage: 'Please enter an email address',
        description: 'Placeholder text for email input fields'
    },
    // gui.homePage.signEmail 请输入邮箱
    signEmail: {
        id: 'gui.homePage.signEmail',
        defaultMessage: 'Please enter an email address',
        description: 'Placeholder text for email input fields'
    },
    errortwoPassWord: {
        id: 'gui.homePage.errortwoPassWord',
        defaultMessage: 'Inconsistent password input',
        description: 'Inconsistent password input'
    },
    turnstileVerifyFailed: {
        id: 'gui.account.turnstileVerifyFailed',
        defaultMessage: 'Human verification failed, please try again.',
        description: 'Turnstile verification failed'
    },
    turnstileMissing: {
        id: 'gui.account.turnstileMissing',
        defaultMessage: 'Verification service is not configured, please contact the administrator.',
        description: 'Turnstile site key missing'
    },
    loadingVerification: {
        id: 'gui.account.loadingVerification',
        defaultMessage: 'Loading verification...',
        description: 'Loading verification widget'
    }
});

// tab 类型
const REGISTER_TAB = 1;
const LOGIN_TAB = 0;
const FORGETPASSWORD_TAB = 2;

const isMobile = username =>
    new RegExp(/^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/).test(username);
const isEmail = username =>
    new RegExp(/^[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/).test(
        username
    );

class LoginModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            password1: '',
            verifyCode: '',
            error: false,
            errorMessage: '',
            isRegister: false,
            isAgree: false,
            isClosed: false,
            // 选择注册账户或者登录账户
            tabIndex: LOGIN_TAB,
            // title: '欢迎来到MatataCode',
            title: this.props.intl.formatMessage(messages.welcomeTitle),
            mode: 'mobile',
            loginType: 'login',
            identifier: null,
            errorCheckboxMessageState: false,
            turnstileToken: null,
            turnstileWidgetId: null,
            // 手机登录子模式：'code'=验证码登录, 'password'=密码登录
            mobileLoginMode: 'code'
        };
        bindAll(this, [
            'handleChange',
            'handleSubmit',
            'handleCode',
            'jumpToTab',
            'modeToggle',
            'headTypeToggle',
            'tryMountTurnstile'
        ]);
    }

    componentDidMount () {
        // 预加载 Turnstile 脚本，减少首次触发验证码的等待
        preloadTurnstile();
        this.tryMountTurnstile(); // 尝试挂载 Turnstile
        FingerprintJS.load()
            .then(fp => {
                fp.get()
                    .then(result => {
                        this.setState({
                            identifier: result.visitorId
                        });
                    });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        // 如果模式改变，尝试重新挂载 Turnstile
        if (prevState.mode !== this.state.mode || prevState.loginType !== this.state.loginType ||
            prevState.mobileLoginMode !== this.state.mobileLoginMode ||
            prevState.tabIndex !== this.state.tabIndex) {
            this.tryMountTurnstile();
        }
    }

    componentWillUnmount() {
        if (this.state.turnstileWidgetId) {
            removeTurnstile(this.state.turnstileWidgetId);
        }
    }

    tryMountTurnstile() {
        const { mode, loginType, turnstileWidgetId, mobileLoginMode, tabIndex } = this.state;

        // 手机模式下，密码登录不需要人机校验
        if (mode !== 'mobile' || mobileLoginMode === 'password') {
            if (turnstileWidgetId) {
                removeTurnstile(turnstileWidgetId);
                this.setState({ turnstileWidgetId: null, turnstileToken: null });
            }
            return;
        }

        const containerId = tabIndex === FORGETPASSWORD_TAB ? 
        'turnstile-forgot-container' : 
        (loginType === 'register' ? 'turnstile-register-container' : 'turnstile-login-container');

        // 使用 setTimeout 确保 DOM 已渲染
        setTimeout(() => {
            const container = document.getElementById(containerId);
            if (container) {
                // 如果已经有 widget 且容器没变（虽然通常 ID 变了 DOM 也就变了，但为了保险），先移除
                // 这里简单起见，只要重新挂载就移除旧的
                if (turnstileWidgetId) {
                    removeTurnstile(turnstileWidgetId);
                }

                mountTurnstile(container, {
                    onSuccess: token => {
                        this.setState({ turnstileToken: token, error: false });
                    },
                    onError: err => {
                        console.error('Turnstile error:', err);
                        this.setState({ turnstileToken: null });
                    },
                    onExpired: () => {
                        this.setState({ turnstileToken: null });
                    }
                }).then(widgetId => {
                    if (widgetId) {
                        this.setState({ turnstileWidgetId: widgetId });
                    }
                });
            }
        }, 0);
    }

    get isChina () {
        const settings = JSON.parse(localStorage.getItem('settings'))
        return settings.languageId === 'zh-cn';
    }

    // 注册或者登录，需要同意协议，忘记密码不需要
    get isNeedAgree () {
        return this.state.tabIndex !== FORGETPASSWORD_TAB;
    }

    // 是否需要校验验证码
    get isNeedVerifyCode () {
        const { mode, mobileLoginMode } = this.state;
        if (mode === 'mobile' && mobileLoginMode === 'password') return false;
        return (
            this.state.mode === 'mobile' || this.state.mode === 'emailRegister'
            // this.state.tabIndex === FORGETPASSWORD_TAB ||
            // this.state.tabIndex == REGISTER_TAB
        );
    }

    // 提交按钮是否可点击
    get submitButtonDisbled () {
        const { username, password, verifyCode, tabIndex, mode, loginType, password1, mobileLoginMode } = this.state;
        // console.log(tabIndex, loginType, mode, 9999)
        // this.state.mode === 'emailLogin' || this.state.mode === 'emailRegister'
        if (tabIndex === FORGETPASSWORD_TAB) {
            return !username || !verifyCode || !password;
        } else if (loginType === 'login') {
            if (mode === 'mobile') {
                return mobileLoginMode === 'password' ? !username || !password : !username || !verifyCode;
            }
            return !username || !password;
            // return mode === 'mobile' ? 
            //     !username || !verifyCode :
            //     !username || !password;
        } else if (loginType === 'register') {
            return mode === 'mobile' ? 
                !username || !verifyCode :
                !username || !password || !verifyCode || !password1;
        }
    }

    // 跳转对应标签页面
    jumpToTab (tabIndex) {
        // 清除输入
        const clearInput = {
            username: '',
            password: '',
            password1: '',
            verifyCode: '',
            error: false
        };
        let val = null
        if (tabIndex === FORGETPASSWORD_TAB) {
            val = this.state.mode;
        } else if (this.state.loginType === 'login') {
            val = tabIndex ? 'emailLogin' : 'mobile'
        } else if (this.state.loginType === 'register') {
            val = tabIndex ? 'emailRegister' : 'mobile'
        }
        this.setState({
            ...clearInput,
            tabIndex: tabIndex,
            mode: val,
            // mode: 'email',
            mobileLoginMode: 'code',
            errorCheckboxMessageState: false,
            title:
                tabIndex === FORGETPASSWORD_TAB ?
                // '重置密码' : '欢迎来到MatataCode'
                this.props.intl.formatMessage(messages.restPasswordTitle) :
                this.props.intl.formatMessage(messages.welcomeTitle)
        });
        // console.log(this.state.tabIndex, 'tabIndex')
    }

    // 切换模式
    modeToggle (mode) {
        this.setState({
            username: '',
            password: '',
            password1: '',
            verifyCode: '',
            error: false,
            mode: mode
        });
    }
    // 头部切换登录、注册
    headTypeToggle (type) {
        let val = null
        if (type === 'register' && this.state.tabIndex === 1) {
            val = 'emailRegister'
        } else if (type === 'login' && this.state.tabIndex === 1) {
            val = 'emailLogin'
        } else {
            val = 'mobile'
        }
        this.setState({
            loginType: type,
            mode: val,
            mobileLoginMode: 'code',
            errorCheckboxMessageState: false
        })
    }
    requestRegister (mode, username, password, verifyCode) {
        new Promise((resolve, reject) => {
            if (mode == 'mobile') {
                requestRegister(resolve, reject, {
                    mobile: username,
                    credentials: verifyCode,
                    accountType: 0,
                    type: 1,
                    identifier: this.state.identifier
                });
            } else {
                requestEmailRegister(resolve, reject, {
                    email: username,
                    password: encryptedData(password),
                    code: verifyCode,
                    type: 0,
                    identifier: this.state.identifier
                });
            }
        })
            .then(response => {
                localStorage.setItem('token', response.data.accessToken);
                this.setState({
                    isClosed: true
                });
                // this.props.onSubmit();
                setTimeout(() => {
                    this.props.onCancel();
                }, 1500);
            })
            .catch(err => {
                this.setState({
                    error: true,
                    // errorMessage: err.msg || '登录错误'
                    errorMessage: err.msg || 
                    <FormattedMessage
                        defaultMessage="Network error, please check your network connection"
                        description="Network error, please check your network connection"
                        id="gui.alerts.networkConnectionError"
                    />
                });
            });
    }

    // 登录api
    requestLogin (mode, username, password, verifyCode) {
        // 存储登录的方式
        this.props.setUserLoginMode(mode);
        new Promise((resolve, reject) => {
            // 账号密码登录，支持邮箱和用户名
            if (mode === 'emailLogin') {
                requestLoginByEmailAndUserName(resolve, reject, {
                    userName: username,
                    password: encryptedData(password),
                    identifier: this.state.identifier
                });
            } else {
                const { mobileLoginMode } = this.state;
                // 手机号登录
                requestLogin(resolve, reject, {
                    accountType: 0,
                    credentials: mobileLoginMode === 'code' ? verifyCode : encryptedData(password),
                    mobile: username,
                    type: mobileLoginMode === 'code' ? 1 : 0,
                    identifier: this.state.identifier
                });
            }
        })
            .then(response => {
                // console.log('parsed json', response);
                localStorage.setItem('token', response.data.accessToken);
                message.success(this.props.intl.formatMessage(messages.loginSuccess)
                    // <FormattedMessage
                    //     defaultMessage="Login succeeded"
                    //     description="Login succeeded"
                    //     id="gui.account.loginSuccess"
                    // />
                );
                this.props.onSuccessFunc()
                // if (response.code === 0) {
                //     this.props.dispatch(closeLoginModal());
                // }
                // disableEvent.cancelSingleDisable('iot_airQuality');
                // disableEvent.cancelSingleDisable('iot_weatherNow');
                // disableEvent.cancelSingleDisable('iot_weatherSun');
                // disableEvent.cancelSingleDisable('iot_addMqttByName');
                // disableEvent.cancelSingleDisable('iot_sendMqttMsgByName');
                // disableEvent.cancelSingleDisable('iot_sendMqttMsgValueByName');
                // disableEvent.cancelSingleDisable('iot_mqttMsgValue');
                this.setState({
                    isClosed: true
                });
                // this.props.onSubmit();
                setTimeout(() => {
                    this.props.onCancel();
                }, 1500);
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: err.msg || 
                    <FormattedMessage
                        defaultMessage="Network error, please check your network connection"
                        description="Network error, please check your network connection"
                        id="gui.alerts.networkConnectionError"
                    />
                });

            });
    }

    // 忘记密码
    async requestForgetPassword (username, password, verifyCode) {
        const { mode } = this.state;
        const isMobileMode = mode === 'mobile';
        try {
            await new Promise((resolve, reject) => {
                if (isMobileMode) {
                    requestForget(resolve, reject, {
                        mobile: username,
                        password: encryptedData(password),
                        code: verifyCode
                    });
                } else {
                    requestForgetByEmail(resolve, reject, {
                        email: username,
                        password: encryptedData(password),
                        code: verifyCode
                    });
                }
            });
            this.setState({
                tabIndex: LOGIN_TAB,
                mode: isMobileMode ? 'mobile' : 'emailLogin',
                loginType: 'login',
                errorCheckboxMessageState: false
            });
            message.success(this.props.intl.formatMessage(messages.resetPasswordSuccess));
        } catch (err) {
            this.setState({
                error: true,
                errorMessage: err.msg ||
                    <FormattedMessage
                        defaultMessage="Network error, please check your network connection"
                        description="Network error, please check your network connection"
                        id="gui.alerts.networkConnectionError"
                    />
            });
        }
    }

    handleChange (event) {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
        // not null
        if (name === 'username' && value.length > 0) {
            this.setState({
                error: false
            });
        }
        if (name === 'password' && value.length > 0) {
            this.setState({
                error: false
            });
        }
        if (name === 'password1' && value.length > 0) {
            this.setState({
                error: false
            });
        }
        if (name === 'verifyCode' && value.length > 0) {
            this.setState({
                error: false
            });
        }
        // checkbox
        if (name === 'isAgree' && value) {
            this.setState({
                error: false,
                errorCheckboxMessageState: false
            });
        }
    }


    handleSubmit (event) {
        event.preventDefault();
        const {username, password, verifyCode, isAgree, tabIndex, mode, loginType, password1} =
            this.state;

        // 验证手机号
        if (mode === 'mobile' && !isMobile(username)) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                    <FormattedMessage
                        id='gui.account.errorMobileFormatMessage'
                        defaultMessage='Mobile format is incorrect'
                        description='Error message for mobile format'
                    />
            }));
            return;
        }

        // 验证邮箱 中文版
        if (this.isChina) {
            if ((mode === 'emailRegister' || mode === 'emailLogin') && !isEmail(username)) {
                this.setState((prevState, props) => ({
                    error: true,
                    errorMessage: 
                        <FormattedMessage
                            id='gui.account.errorEmailFormatMessage'
                            defaultMessage='Email format is incorrect'
                            description='Error message for email format'
                        />
                }));
                return
            }
        }
        // 验证邮箱 英文版
        if (!this.isChina && (mode === 'emailRegister' || mode === 'emailLogin') && !isEmail(username)) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                <FormattedMessage
                    id='gui.account.errorEmailFormatMessage'
                    defaultMessage='Email format is incorrect'
                    description='Error message for email format'
                />
            }));
            return
        }
        // checkbox
        if (this.isNeedAgree && !isAgree) {
            this.setState((prevState, props) => ({
                // error: true,
                errorCheckboxMessageState: true,
                errorMessage: <FormattedMessage
                    id='gui.account.errorCheckboxMessage2'
                    defaultMessage='Please read and agree to the User Agreement'
                    description='Error message for checkbox'
                />
            }));
            return;
        }
        // 注册时 对比两次密码是否一致
        if (mode === 'emailRegister' && loginType === 'register' ||
            tabIndex === FORGETPASSWORD_TAB) {
            if (password !== password1) {
                this.setState((prevState, props) => ({
                    error: true,
                    errorMessage: 
                    <FormattedMessage
                        id='gui.homePage.errortwoPassWord'
                        defaultMessage='Inconsistent password input'
                        description='Inconsistent password input'
                    />
                }));
                return;
            }
            
        }
        // verifyCode
        if (this.isNeedVerifyCode && !verifyCode) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                    <FormattedMessage
                        id='gui.account.errorCodeEmptyMessage'
                        defaultMessage='Verification code cannot be empty'
                        description='Error message for empty input'
                    />
            }));
            return;
        }

        // 国外只允许使用邮箱,国内手机号，邮箱都可以
        // const isEmailorMobile = (username)=> new RegExp(/（^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$）|（^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$）/i).test(username);

        // const testWay =  this.isChina?isEmailorMobile:isMobile;
        // const type = isMobile(username)?'mobile':'email';
        // if(testWay(usename)){
        //     this.setState((prevState, props) => ({
        //         error: true,
        //         errorMessage:'格式不正确',
        //         // errorMessage: props.intl.formatMessage(
        //         //     messages.errorCodeEmptyMessage
        //         // )
        //     }));
        //     return;
        // }
        // login or register
        // loginType === 'login'
        // 邮箱登录
        if (tabIndex === FORGETPASSWORD_TAB) {
            this.requestForgetPassword(username, password, verifyCode);
        } else if (loginType === 'login') {
            this.requestLogin(mode, username, password, verifyCode);
        } else if (loginType === 'register') {
            this.requestRegister(mode, username, password, verifyCode);
        }
    }

    /**
     *  获取邮箱验证码
     */
    async handleCode () {
        // event.preventDefault();
        const {username, isAgree, tabIndex, mode, loginType} = this.state;
        // 没有输入邮箱或者用户名
        if (!username) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                <FormattedMessage
                    id='gui.account.emailPlaceholder'
                    defaultMessage='Please enter an email address'
                    description='Placeholder text for email input field'
                />
            }));
            return;
        }
        // 没有同意协议
        if (this.isNeedAgree && !isAgree) {
            this.setState((prevState, props) => ({
                // error: true,
                errorCheckboxMessageState: true,
                errorMessage:
                <FormattedMessage
                    id='gui.account.errorCheckboxMessage2'
                    defaultMessage='Please read and agree to the User Agreement'
                    description='Error message for checkbox'
                />
            }));
            return;
        }
        // 如果是邮箱，验证邮箱格式
        if ((mode === 'emailRegister' || mode === 'emailLogin') && !isEmail(username)) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                <FormattedMessage
                    id='gui.account.errorEmailFormatMessage'
                    defaultMessage='Email format is incorrect'
                    description='Error message for email format'
                />
            }));
            return;
        }
        // 如果是手机号，验证手机号格式
        if (mode === 'mobile' && !isMobile(username)) {
            this.setState((prevState, props) => ({
                error: true,
                errorMessage: 
                <FormattedMessage
                    id='gui.account.errorMobileFormatMessage'
                    defaultMessage='Mobile format is incorrect'
                    description='Error message for mobile format'
                />
            }));
            return;
        }

        let turnstileToken = null;
        if (mode === 'mobile') {
            turnstileToken = this.state.turnstileToken;
            if (!turnstileToken) {
                // 如果没有 Token，可能是还没验证或验证失败/过期
                // 这里可以提示用户，或者尝试重新触发（如果是 invisible 模式）
                // 但我们现在是 visible 模式，用户应该能看到验证框
                this.setState((prevState, props) => ({
                    error: true,
                    errorMessage: props.intl.formatMessage(messages.turnstileVerifyFailed)
                }));
                return false;
            }
        }

        const res = await new Promise((resolve, reject) => {
            if (mode === 'emailRegister' || mode === 'emailLogin') {
                requestEmailCode(resolve, reject, {
                    email: username,
                    type: tabIndex === 1 ? 1 : 2 // ,登录或注册 2,忘记密码
                });
            } else if (mode === 'mobile') {
                requestMobileCode(resolve, reject, {
                    mobile: username,
                    type: tabIndex === FORGETPASSWORD_TAB ? 2 : (loginType === 'register' ? 0 : 1),
                    turnstileToken
                    // type: tabIndex === REGISTER_TAB ? 0 : 1 // 0:注册，1：登录
                });
            }
        }).then(() => true)
            .catch(err => {
                console.log('获取验证码失败');
                this.setState({
                    error: true,
                    errorMessage: err.msg || 
                    <FormattedMessage
                        defaultMessage="Network error, please check your network connection"
                        description="Network error, please check your network connection"
                        id="gui.alerts.networkConnectionError"
                    />
                });
                return false;
            });
        return res;

    }

    // 禁止input number滚动时的加减
    handleStopScroll (evt) {
        evt = evt || window.event;
        if (evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        } else {
            evt.cancelBubble = true;
            evt.returnValue = false;
        }
        return false;
    }

    // 登录模态主要内容
    getBox (username, password, verifyCode, isAgree, error, errorMessage, password1) {
        const {tabIndex} = this.state;
        if (tabIndex === FORGETPASSWORD_TAB) {
            const { mode } = this.state;
            return (
                <div className="accountBox">
                    <img
                        className="back-icon"
                        src={backIcon}
                        draggable={false}
                        onClick={() => this.jumpToTab(LOGIN_TAB)}
                    />
                    <div style={{ paddingTop: '32px' }}>
                        <Input
                            required
                            className={getMobileOS() === 'PC' ? "emailInputpc" : "emailInput"}
                            name="username"
                            placeholder={this.props.intl.formatMessage(
                                mode === 'mobile' ? messages.mobilePlaceholder : messages.emailPlaceholder
                            )}
                            type="text"
                            value={username}
                            onChange={this.handleChange}
                        />
                        <br />
                        <React.Fragment>
                            {/* 获取验证码 */}
                            <div className="codeBox">
                                <Input
                                    className={getMobileOS() === 'PC' ? "verifyCodeInputpc" : "verifyCodeInput"}
                                    name="verifyCode"
                                    onWheelCapture={e => {
                                        e.target.blur();
                                    }}
                                    placeholder={this.props.intl.formatMessage(messages.codePlaceholder)}
                                    type="number"
                                    value={verifyCode}
                                    onChange={this.handleChange}
                                />
                                <VerifyCode
                                    disabled={!username}
                                    onClick={this.handleCode}
                                />
                            </div>
                        </React.Fragment>
                        <Input.Password
                            required
                            className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                            name="password"
                            placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
                            type="password"
                            value={password}
                            onChange={this.handleChange}
                        />
                        <br />
                        <Input.Password
                            required
                            className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                            name="password1"
                            placeholder={this.props.intl.formatMessage(messages.passwordConfirm)}
                            type="password"
                            value={password1}
                            onChange={this.handleChange}
                        />
                        {/* 只有手机模式才需要人机校验 */}
                        {this.state.mode === 'mobile' && (
                            <React.Fragment>
                                <div
                                    id="turnstile-forgot-container"
                                    style={{ marginTop: '10px', minHeight: this.state.turnstileWidgetId ? 'auto' : '0' }}
                                />
                                {!this.state.turnstileWidgetId && (
                                    <div style={{ color: '#999', fontSize: '12px', marginTop: '10px' }}>
                                        <FormattedMessage {...messages.loadingVerification} />
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                        <SubmitLoginButton
                            className="btnContainer"
                            tabIndex={tabIndex}
                            onClick={this.handleSubmit}
                            disabled={this.submitButtonDisbled}
                        />
                        <div style={{marginTop: '16px'}} />
                        {error && (
                            <div className="error">{errorMessage}</div>
                        )}
                    </div>
                </div>
            );
        }
        return (
            <div className="accountBox">
                {/* // 头部切换 、手机登录-邮箱登录 、手机注册-邮箱注册 */}
                <Tabs
                    className="tabsContainer"
                    selectedIndex={tabIndex}
                    onChange={index => {
                        this.jumpToTab(index);
                    }}
                >
                    {this.state.loginType === 'login' && 
                        <TabList className="tabListLogin">
                            <Tab
                                className={tabIndex === 0 ? "tabItem active" : "tabItem"}
                            >
                                {/* 手机登录 */}
                                <FormattedMessage
                                    defaultMessage="Mobile login"
                                    description="Mobile login"
                                    id="gui.homePage.phoneLogin"
                                />
                            </Tab>
                            <Tab
                                className={tabIndex === 1 ? "tabItem active" : "tabItem"}
                            >
                                {/* 邮箱登录 */}
                                <FormattedMessage
                                    defaultMessage="Email login"
                                    description="Email login"
                                    id="gui.homePage.emailLogin"
                                />
                            </Tab>
                        </TabList>
                    }
                    {this.state.loginType === 'register' && 
                        <TabList className="tabListLogin">
                            <Tab
                                className={tabIndex === LOGIN_TAB ? "tabItem active" : "tabItem"}
                            >
                                {/* 手机注册 */}
                                <FormattedMessage
                                    defaultMessage="Mobile register"
                                    description="Mobile register"
                                    id="gui.homePage.phoneRegister"
                                />
                            </Tab>
                            <Tab
                                className={tabIndex === REGISTER_TAB ? "tabItem active" : "tabItem"}
                            >
                                {/* 邮箱注册 */}
                                <FormattedMessage
                                    defaultMessage="Email register"
                                    description="Email register"
                                    id="gui.homePage.emailRegister"
                                />
                            </Tab>
                        </TabList>
                    }
                    {/* 表单展示登录 */}
                    <div onSubmit={this.handleSubmit}>
                        {/* mode === 'mobile' 手机号登录 */}
                        {/* 登录页面整体页面 */}
                        { this.state.loginType === 'login' && 
                            <div>
                                {/* 手机登录 */}
                                <TabPanels>
                                    <TabPanel>
                                        <Input
                                            required
                                            className={getMobileOS() === 'PC' ? "emailInputpc" : "emailInput"}
                                            name="username"
                                            placeholder={this.props.intl.formatMessage(messages.mobilePlaceholder)}
                                            type="text"
                                            value={username}
                                            onChange={this.handleChange}
                                        />
                                        <br />
                                        {this.state.mobileLoginMode === 'code' ? (
                                            /* 验证码登录 */
                                            <React.Fragment>
                                                <div className="codeBox">
                                                    <Input
                                                        className={
                                                            getMobileOS() === 'PC' ? "verifyCodeInputpc" : "verifyCodeInput"
                                                        }
                                                        name="verifyCode"
                                                        onWheelCapture={e => { e.target.blur(); }}
                                                        placeholder={this.props.intl.formatMessage(messages.codePlaceholder)}
                                                        type="number"
                                                        value={verifyCode}
                                                        onChange={this.handleChange}
                                                    />
                                                    <VerifyCode
                                                        disabled={!username}
                                                        onClick={this.handleCode}
                                                    />
                                                </div>
                                                <div
                                                    id="turnstile-login-container"
                                                    style={{ marginTop: '10px', minHeight: this.state.turnstileWidgetId ? 'auto' : '0' }}
                                                />
                                                {!this.state.turnstileWidgetId && (
                                                    <div style={{ color: '#999', fontSize: '12px', marginTop: '10px' }}>
                                                        <FormattedMessage {...messages.loadingVerification} />
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        ) : (
                                            /* 密码登录 */
                                            <div className="passwordBox">
                                                <Input.Password
                                                    required
                                                    className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                                                    name="password"
                                                    placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
                                                    value={password}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        )}
                                    </TabPanel>
                                
                                    {/* 邮箱登录 */}
                                    <TabPanel>
                                        <Input
                                            required
                                            className={getMobileOS() === 'PC' ? "emailInputpc" : "emailInput"}
                                            name="username"
                                            placeholder={this.props.intl.formatMessage(messages.emailPlaceholder)}
                                            type={'email'}
                                            value={username}
                                            onChange={this.handleChange}
                                        />
                                        <br />

                                        <React.Fragment>
                                            {/* 密码登录 */}
                                            <div className="passwordBox">
                                                <Input.Password
                                                    required
                                                    className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                                                    name="password"
                                                    placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
                                                    type="password"
                                                    value={password}
                                                    onChange={this.handleChange}
                                                />
                                                {/* <div
                                                    className={getMobileOS() === 'PC' ? styles.forgetpwdBoxpc : styles.forgetpwdBox}
                                                >
                                                    <span
                                                        onClick={() =>
                                                            this.jumpToTab(
                                                                FORGETPASSWORD_TAB
                                                            )
                                                        }
                                                    >{this.props.intl.formatMessage(
                                                            messages.forgetPassword
                                                        )}</span>

                                                </div> */}
                                            </div>
                                        </React.Fragment>
                                    </TabPanel>
                                </TabPanels>
                            </div>
                        }
                        {/* 注册页面整体页面 */}
                        { this.state.loginType === 'register' && 
                            <div>
                                {/* 手机注册验证码 */}
                                <TabPanels>
                                    <TabPanel>
                                        <Input
                                            required
                                            className={getMobileOS() === 'PC' ? "emailInputpc" : "emailInput"}
                                            name="username"
                                            placeholder={this.props.intl.formatMessage(messages.mobilePlaceholder)}
                                            type={'text'}
                                            value={username}
                                            onChange={this.handleChange}
                                        />
                                        <br />
                                        {/* 验证码登录 */}
                                        <React.Fragment>
                                            {/* 获取验证码 */}
                                            <div className="codeBox">
                                                <Input
                                                    className={
                                                        getMobileOS() === 'PC' ? "verifyCodeInputpc" : "verifyCodeInput"
                                                    }
                                                    name="verifyCode"
                                                    onWheelCapture={e => {
                                                        e.target.blur();
                                                    }}
                                                    placeholder={this.props.intl.formatMessage(messages.codePlaceholder)}
                                                    type="number"
                                                    value={verifyCode}
                                                    onChange={this.handleChange}
                                                />
                                                <VerifyCode
                                                    disabled={!username}
                                                    onClick={this.handleCode} // 0:注册 1，登录
                                                />
                                            </div>
                                            <div
                                                id="turnstile-register-container"
                                                style={{ marginTop: '10px', minHeight: this.state.turnstileWidgetId ? 'auto' : '0' }}
                                            />
                                            {!this.state.turnstileWidgetId && (
                                                <div style={{ color: '#999', fontSize: '12px', marginTop: '10px' }}>
                                                    <FormattedMessage {...messages.loadingVerification} />
                                                </div>
                                            )}
                                            <br />
                                        </React.Fragment>
                                        <br />
                                    </TabPanel>
                                    {/* 邮箱注册 */}
                                    <TabPanel>
                                        <Input
                                            required
                                            className={getMobileOS() === 'PC' ? "emailInputpc" : "emailInput"}
                                            name="username"
                                            placeholder={this.props.intl.formatMessage(messages.emailPlaceholder)}
                                            type={'email'}
                                            value={username}
                                            onChange={this.handleChange}
                                        />
                                        <br />

                                        <React.Fragment>
                                            {/* 密码登录 */}
                                            <div className="passwordBox">
                                                <Input.Password
                                                    required
                                                    className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                                                    name="password"
                                                    placeholder={this.props.intl.formatMessage(messages.passwordPlaceholder)}
                                                    type="password"
                                                    value={password}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            {/* 密码确认 */}
                                            <div className="passwordBox">
                                                <Input.Password
                                                    required
                                                    className={getMobileOS() === 'PC' ? "pwdInputpc" : "pwdInput"}
                                                    name="password1"
                                                    placeholder={this.props.intl.formatMessage(messages.passwordConfirm)}
                                                    type="password"
                                                    value={password1}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            {/* 获取验证码 */}
                                            <div className="codeBox">
                                                <Input
                                                    className={
                                                        getMobileOS() === 'PC' ? "verifyCodeInputpc" : "verifyCodeInput"
                                                    }
                                                    name="verifyCode"
                                                    onWheelCapture={e => {
                                                        e.target.blur();
                                                    }}
                                                    placeholder={this.props.intl.formatMessage(messages.codePlaceholder)}
                                                    type="number"
                                                    value={verifyCode}
                                                    onChange={this.handleChange}
                                                />
                                                <VerifyCode
                                                    disabled={!username}
                                                    onClick={this.handleCode} // 0:注册 1，登录
                                                />
                                            </div>
                                            <div
                                                ref={el => (this.turnstileContainer = el)}
                                                style={{ marginTop: '10px' }}
                                            />
                                            <br />
                                        </React.Fragment>
                                        <br />
                                    </TabPanel>
                                </TabPanels>
                            </div>
                        }
                    </div>
                </Tabs>
                <div className="btnContainer">
                    {/* 隐私协议和用户协议 */}
                    <Popover 
                        placement="topLeft" 
                        content={
                            <FormattedMessage
                                id='gui.account.errorCheckboxMessage2'
                                defaultMessage='Please read and agree to the User Agreement'
                                description='Error message for checkbox'
                            />
                        }
                        open={this.state.errorCheckboxMessageState}
                        // arrow={mergedArrow}
                    >
                        <div className="privacy">
                            <input
                                className="checkboxRound"
                                name="isAgree"
                                type="checkbox"
                                checked={isAgree}
                                onChange={this.handleChange}
                            />
                            {/* <div className={styles.round}> */}
                            {/*     <input */}
                            {/*         type="checkbox" */}
                            {/*         id="checkbox" */}
                            {/*         name="isAgree" */}
                            {/*         checked={isAgree} */}
                            {/*         onChange={this.handleChange} */}
                            {/*     /> */}
                            {/*     <label htmlFor="checkbox" /> */}
                            {/* </div> */}
                            {/* 我已阅读并同意 */}
                                <FormattedMessage
                                    defaultMessage="I agree to the"
                                    description="Label for submit login"
                                    id="gui.account.privacy"
                                />
                            &nbsp;
                            {/* eslint-disable-next-line no-script-url */}
                            <a
                                style={{whiteSpace:"nowrap", color:'#3073ff'}}
                                href="https://shop.matatalab.com/pages/privacy-policy"
                                target="view_window"
                            >
                                {/* 隐私政策 */}
                                <FormattedMessage
                                    defaultMessage="Privacy Policy"
                                    id="gui.telemetryOptIn.privacyPolicyLink"
                                />
                            </a>
                            &nbsp;
                            {/* 和 */}
                            <FormattedMessage
                                defaultMessage="and"
                                id="gui.account.and"
                            />
                            &nbsp;
                            {/* eslint-disable-next-line no-script-url */}
                            <a
                                style={{whiteSpace:"nowrap", color:'#3073ff'}}
                                href="https://matatalab.com/app/user_agreement.html"
                                target="view_window"
                            >
                                {/* 用户协议 */}
                                <FormattedMessage
                                    defaultMessage="User agreement"
                                    id="gui.account.userAgreement"
                                />
                            </a>
                        </div>
                    </Popover>
                    <SubmitLoginButton
                        // className={this.state.tabIndex==1?styles.fixedtnContainer:styles.fixedtnContainer}
                        tabIndex={this.state.tabIndex}
                        loginType={this.state.loginType}
                        onClick={this.handleSubmit}
                        disabled={this.submitButtonDisbled}
                    />
                    {error && (
                        <div className="error">{errorMessage}</div>
                    )}
                    <div className="loginFooter">
                        {this.state.mode === 'emailLogin' ? 
                            <div
                                className="modeToggleLeft"
                            >
                                <span
                                    onClick={() =>
                                        this.jumpToTab(
                                            FORGETPASSWORD_TAB
                                        )
                                    }
                                >
                                    {/* 忘记密码 */}
                                    <FormattedMessage
                                        defaultMessage="Forgot?"
                                        description="Forgot?"
                                        id="gui.account.forgetPassword"
                                    />
                                    {/* {this.props.intl.formatMessage(
                                        messages.forgetPassword
                                    )} */}
                                </span>
                            </div> :
                            <React.Fragment>
                                {/* 仅手机登录时显示：验证码 ↔ 密码 切换 */}
                                {this.state.mode === 'mobile' && this.state.loginType === 'login' && (
                                    <div className="modeToggleLeft">
                                        <span
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => this.setState(prev => ({
                                                mobileLoginMode: prev.mobileLoginMode === 'code' ? 'password' : 'code',
                                                password: '',
                                                verifyCode: '',
                                                error: false
                                            }))}
                                        >
                                            {
                                                this.state.mobileLoginMode === 'code' ?
                                                    this.props.intl.formatMessage(messages.loginByPwd) :
                                                    this.props.intl.formatMessage(messages.loginByCode)
                                            }
                                        </span>
                                    </div>
                                )}
                                <div
                                    className="modeToggleLeft"
                                >
                                    <span
                                        onClick={() =>
                                            this.jumpToTab(
                                                FORGETPASSWORD_TAB
                                            )
                                        }
                                    >
                                        {/* 忘记密码 */}
                                        <FormattedMessage
                                            defaultMessage="Forgot?"
                                            description="Forgot?"
                                            id="gui.account.forgetPassword"
                                        />
                                    </span>
                                </div>
                            </React.Fragment>
                        }
                        {this.state.loginType === 'login' && 
                            <div
                                className="modeToggle"
                                // justifyContent="flex-end"
                            >
                                <span
                                    onClick={() => {
                                        this.headTypeToggle('register');
                                    }}
                                >
                                    {/* 立即注册 */}
                                    <FormattedMessage
                                        defaultMessage="Register"
                                        description="Label for sign up"
                                        id="gui.account.signUpLong"
                                    />
                                </span>
                            </div>
                        }
                        {this.state.loginType === 'register' && 
                            <div
                                className="modeToggle"
                                // justifyContent="flex-end"
                            >
                                <span
                                    onClick={() => {
                                        this.headTypeToggle('login');
                                    }}
                                >
                                    {/* 立即登录 */}
                                    <FormattedMessage
                                        defaultMessage="Login"
                                        description="Label for sign up"
                                        id="gui.account.signInLong"
                                    />
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }

    getMessage () {
        // login success
        return (
            <div className="succeedMessage">
                {/* 登录成功 */}
                {this.props.intl.formatMessage(messages.loginSuccess)}
            </div>
        );
    }

    render () {
        // const {intl, onClose, isOpen} = this.props;
        const {
            username,
            password,
            password1,
            verifyCode,
            error,
            errorMessage,
            isAgree,
            isClosed
        } = this.state;
        return (
            <WrapLoginModal
                className="modalContentLogin"
                contentLabel={this.state.title}
                id="loginModal"
                onRequestClose={this.props.onCancel}
                isDividerShown
                isRtl={this.props.isRtl}
                headerImageTop={modalHeadBack}
            >
                {isClosed ?
                    this.getMessage() :
                    this.getBox(
                        username,
                        password,
                        verifyCode,
                        isAgree,
                        error,
                        errorMessage,
                        password1,
                    )}
            </WrapLoginModal>
        );
    }
}

LoginModal.propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    // intl: injectIntl,
    loginError: PropTypes.string,
    isRtl: PropTypes.bool,
    currentLocale: PropTypes.string,
    onSuccessFunc: PropTypes.func,
    setUserLoginMode: PropTypes.func
};

LoginModal.defaultProps = {
    onCancel: () => {
        // closeLoginModal();
    },
    loginError: ''
};

const mapStateToProps = (state, ownProps) => ({
    // isRtl: state.locales.isRtl,
    // currentLocale: state.locales.locale // 当前的语言
    // mode: state.scratchGui.userState.mode
});

const mapDispatchToProps = dispatch => ({
    setUserLoginMode: mode => dispatch(setUserLoginMode(mode))
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(LoginModal);
// export default LoginModal;